import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import contentData from '../data/content.json';

const StarVolunteerCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const starVolunteers = contentData.starVolunteers;

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % starVolunteers.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + starVolunteers.length) % starVolunteers.length);
  };

  useEffect(() => {
    const timer = setInterval(nextSlide, 8000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative max-w-5xl mx-auto">
      <div className="overflow-hidden">
        <div
          className="flex transition-transform duration-500 ease-in-out"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {starVolunteers.map((volunteer) => (
            <div key={volunteer.id} className="min-w-full px-2">
              <Card className="border-2 border-warm-amber shadow-xl">
                <CardContent className="p-6 md:p-8">
                  <div className="flex items-center justify-center mb-6">
                    <div className="flex items-center gap-2 bg-warm-amber text-white px-6 py-3 rounded-full">
                      <Star className="w-5 h-5" fill="currentColor" />
                      <span className="font-bold text-lg">Star Volunteer</span>
                    </div>
                  </div>

                  <div className="grid md:grid-cols-3 gap-6 items-center">
                    <div className="md:col-span-1 flex justify-center">
                      <div className="relative">
                        <img
                          src={volunteer.image}
                          alt={volunteer.name}
                          className="w-48 h-48 rounded-full object-left-top object-cover border-4 border-warm-amber shadow-lg"
                        />
                        <div className="absolute -bottom-2 -right-2 bg-forest-green text-white px-4 py-1 rounded-full text-sm font-semibold">
                          {volunteer.month}
                        </div>
                      </div>
                    </div>

                    <div className="md:col-span-2">
                      <h3 className="text-3xl font-bold font-heading text-forest-green mb-4">
                        {volunteer.name}
                      </h3>
                      <p className="text-gray-700 text-base leading-relaxed mb-4">
                        {volunteer.description}
                      </p>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        {volunteer.fullText}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Buttons */}
      <Button
        onClick={prevSlide}
        className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white hover:bg-warm-amber text-forest-green hover:text-white rounded-full p-2 shadow-lg transition-all"
        size="icon"
      >
        <ChevronLeft className="w-6 h-6" />
      </Button>

      <Button
        onClick={nextSlide}
        className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white hover:bg-warm-amber text-forest-green hover:text-white rounded-full p-2 shadow-lg transition-all"
        size="icon"
      >
        <ChevronRight className="w-6 h-6" />
      </Button>

      {/* Dots Indicator */}
      <div className="flex justify-center gap-2 mt-6">
        {starVolunteers.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all ${index === currentSlide
              ? 'bg-warm-amber w-8'
              : 'bg-gray-300 hover:bg-gray-400'
              }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default StarVolunteerCarousel;
